import React, { useMemo } from "react";
import P from "components/P";
import FlexChild from "layouts/flex/FlexChild";
import HorizontalFlex from "layouts/flex/HorizontalFlex";
import VerticalFlex from "layouts/flex/VerticalFlex";
import Center from "layouts/wrapper/Center";
import style from "./SkeletonProductCard.module.css";
import Dummy from "components/Dummy";

const SkeletonProductCard = React.memo(function SkeletonProductCard(props) {
  const skeletonContent = useMemo(() => {
    if (!props.isLoading && !props.isDummy) return null;

    return (
      <div
        style={{
          display: "flex",
          flex: props.flex ? props.flex : "1 0 17%",
          justifyContent: "center",
          alignItems: "center",
          borderRadius: "3px",
          opacity: props.isDummy ? 0 : 1, // 더미일 경우 투명하게
        }}
      >
        <div style={{ width: "100%", position: "relative" }}>
          <VerticalFlex gap={10}>
            <FlexChild>
              <div className={style.productCard}>
                <VerticalFlex>
                  <FlexChild>
                    <div
                      style={{
                        borderTopLeftRadius: "3px",
                        borderTopRightRadius: "3px",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        backgroundSize: "cover",
                      }}
                    >
                      <div
                        className={style.skeleton}
                        style={{ width: "100%", height: "224px" }}
                      ></div>
                    </div>
                  </FlexChild>
                  <FlexChild>
                    <Center width={"130px"}>
                      <Dummy height={"10px"} />
                      <div
                        className={style.skeleton}
                        style={{ width: "100%", height: "30px" }}
                      ></div>
                      <Dummy height={"1px"} />
                      <div
                        className={style.skeleton}
                        style={{ width: "100%", height: "30px" }}
                      ></div>
                      <Dummy height={"1px"} />
                    </Center>
                  </FlexChild>
                </VerticalFlex>
              </div>
            </FlexChild>
            <FlexChild width={"100%"}>
              <div className={`${style.addCartButton} ${style.skeleton}`}>
                <Center>
                  <div style={{ width: "100%", height: "52px" }}></div>
                </Center>
              </div>
            </FlexChild>
          </VerticalFlex>
        </div>
      </div>
    );
  }, [props.isLoading, props.isDummy, props.flex]);

  return skeletonContent;
});

export default SkeletonProductCard;